import { DefaultService } from '@/services/DefaultService';

export default class DespesaAutomaticaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(form) {
        return this._http.post(`${this._env}/despesa/despesaautomatica`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllUserWorkAutoKm() {
        return this._http.get(`${this._env}/despesa/despesaautomatica/list.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao buscar usuarios que trabalham com despesa automatica');
        });
    }

    buscaTodosUsuarios() {
        return this._http.get(`${this._env}/despesa/despesaautomatica/busca-todos-usuarios`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao buscar usuarios');
        });
    }

    //true or false se possui despesa automatica
    possuiDespesaAutomatica() {
        return this._http.get(`${this._env}/despesa/despesaautomatica/trabalha`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao buscar usuarios que trabalham com despesa automatica');
        });
    }
    
    //true or false se possui valor km ativo
    possuiValorKmAtivo() {
        return this._http.get(`${this._env}/despesa/despesaautomatica/valorkm`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao buscar valor km ativo');
        });
    }

    //true or false se possui valor km ativo
    hasGmapKey() {
        return this._http.get(`${this._env}/despesa/despesaautomatica/verifica-apikey-gmaps`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao buscar se usuario trabalha possui key do gmaps cadastrada');
        });
    }

    hasGmapsKeyAndUserKmAuto(idusuario) {
        return this._http.get(encodeURI(`${this._env}/despesa/despesaautomatica/verificar?idusuario=${idusuario}`), this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    //true or false se possui despesa para ser gerada
    existeCheckPendente(obj) {
        return this._http.post(`${this._env}/despesa/existecheckpendente`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    //GERA DESPESAS PENDENTES PARA USUARIO ESPECIFICO
    geraDespesaAutomatica(idusuario) {
        return this._http.get(`${this._env}/despesa/geradespesaautomatica?idusuario=${idusuario}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
}